<template>
  <a-row :gutter="16">
    <a-col :xxl="4" :xl="6" :lg="8" :md="12">
      <a-range-picker v-model:value="queryForm.daterange" :ranges="ranges" :locale="locale" value-format="YYYY-MM-DD"
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.platform" :options="qplatforms" show-select style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-input v-model:value="queryForm.trade_number" placeholder="订单编号" style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="refresh">查询</a-button>
    </a-col>
  </a-row>
  <div class="d-flex justify-space-between align-center mb-2 mt-2">
    <a-space>
      <a-button type="link" @click="refresh">刷新数据</a-button>
    </a-space>
    <a-space>
      <a-dropdown>
        <template #overlay>
          <a-menu>
            <a-menu-item @click="add">新增收款明细</a-menu-item>
            <a-menu-item @click="importData">导入收款明细</a-menu-item>
          </a-menu>
        </template>
        <a-button type="primary">
          新增数据
          <DownOutlined />
        </a-button>
      </a-dropdown>
      <a-dropdown>
        <template #overlay>
          <a-menu>
            <a-menu-item @click="exportselected" :disabled="selectedRowKeys.length === 0">导出勾选</a-menu-item>
            <a-menu-item @click="exportall">导出所有页</a-menu-item>
            <a-menu-item @click="exporttask" class="text-error">查看导出任务</a-menu-item>
          </a-menu>
        </template>
        <a-button type="primary">
          导出数据
          <DownOutlined />
        </a-button>
      </a-dropdown>
    </a-space>
  </div>
  <div class="static">
    <a-row>
      <a-col :span="12">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">收款次数</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="收款次数" :value="total_count" style="margin-right: 50px" />
      </a-col>
      <a-col :span="12">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">收款金额(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="收款金额(¥)" :precision="2" :value="total_amount" />
      </a-col>
    </a-row>
  </div>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="{ current: page, pageSize: limit, total: count, showQuickJumper: true, showSizeChanger: true, showTotal: (total) => `共${total}条`, }"
    @change="(pagination) => { page = pagination.current; limit = pagination.pageSize; }" row-key="_id"
    :row-selection="{ selectedRowKeys, onChange: (keys) => selectedRowKeys = keys }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'sub_account'">
        <p>{{ record.sub_account_number }}</p>
        <p>{{ record.sub_account_name }}</p>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="tradeModal" title="新增收款明细" @ok="save" @cancel="cancelSave" ok-text="确认" cancel-text="取消"
    :confirm-loading="saving" :cancel-button-props="{ disabled: saving }" :maskClosable="false" :closable="!saving"
    width="600px">
    <a-form ref="tradeFormRef" name="tradeForm" :model="tradeForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
      autocomplete="off">
      <a-row>
        <a-col :span="24">
          <a-form-item label="商户" name="orgid" :rules="[{ required: true, message: '请选择商户' }]">
            <a-select v-model:value="tradeForm.orgid" :options="sorgs" :filter-option="$filters.filterOption"
              placeholder="请选择" :disabled="saving" show-search style="width:100%;" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="收款平台" name="platform" :rules="[{ required: true, message: '请选择收款平台' }]">
            <a-select v-model:value="tradeForm.platform" :options="platforms" placeholder="请选择" :disabled="saving">
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="订单编号" name="trade_number" :rules="[{ required: true, message: '请输入订单编号' }]">
            <a-input v-model:value="tradeForm.trade_number" placeholder="订单编号" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <template v-if="tradeForm.platform === '艾贝盈'">
          <a-col :span="24">
            <a-form-item label="子账户号码" name="sub_account_number" :rules="[{ required: true, message: '请输入子账户号码' }]">
              <a-input v-model:value="tradeForm.sub_account_number" placeholder="子账户号码" :disabled="saving">
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="子账户名称" name="sub_account_name" :rules="[{ required: true, message: '请输入子账户名称' }]">
              <a-input v-model:value="tradeForm.sub_account_name" placeholder="子账户名称" :disabled="saving">
              </a-input>
            </a-form-item>
          </a-col>
        </template>
        <template v-if="tradeForm.platform === '连连'">
          <a-col :span="24">
            <a-form-item label="收款账号" name="receive_account_number" :rules="[{ required: true, message: '请输入收款账号' }]">
              <a-input v-model:value="tradeForm.receive_account_number" placeholder="收款账号" :disabled="saving">
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="店铺名称" name="shop_name" :rules="[{ required: true, message: '请输入店铺名称' }]">
              <a-input v-model:value="tradeForm.shop_name" placeholder="店铺名称" :disabled="saving">
              </a-input>
            </a-form-item>
          </a-col>
        </template>
        <a-col :span="24">
          <a-form-item label="交易金额" name="amount" :rules="[{ required: true, message: '请输入交易金额' }]">
            <a-input v-model:value="tradeForm.amount" type="number" placeholder="交易金额" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="币种" name="currency" :rules="[{ required: true, message: '请选择币种' }]">
            <a-select v-model:value="tradeForm.currency" :options="currencys" placeholder="请选择" :disabled="saving" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="结算汇率" name="settlement_exchange_rate" :rules="[{ required: true, message: '请输入结算汇率' }]">
            <a-input v-model:value="tradeForm.settlement_exchange_rate" type="number" placeholder="结算汇率"
              :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="交易时间" name="trade_time" :rules="[{ required: true, message: '请选择交易时间' }]">
            <a-date-picker v-model:value="tradeForm.trade_time" :locale="locale" :show-now="true"
              :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }" :show-today="true"
              value-format="YYYY-MM-DD HH:mm:ss" style="width:100%" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
  <Upload ref="uploadRef" />
  <Download ref="downloadRef" />
</template>
<script setup>
import dayjs from "dayjs";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import Upload from "@/components/upload.vue";
import Download from "@/components/download.vue";
import { ref, watch, computed, onMounted, onActivated, getCurrentInstance, } from "vue";
import _ from "underscore";
const { proxy } = getCurrentInstance();

const columns = [
  { title: '商户', dataIndex: 'org', width: 120 },
  { title: '收款平台', dataIndex: 'platform', width: 80, },
  { title: '订单编号', dataIndex: 'trade_number', width: 220 },
  { title: '子账户', dataIndex: 'sub_account', width: 200 },
  { title: '收款账号', dataIndex: 'receive_account_number', width: 200 },
  { title: '店铺名称', dataIndex: 'shop_name', width: 120 },
  { title: '交易金额', dataIndex: 'amount', width: 100, },
  { title: '币种', dataIndex: 'currency', width: 100, },
  { title: '结算汇率', dataIndex: 'settlement_exchange_rate', width: 100, },
  { title: '交易时间', dataIndex: 'trade_time', width: 120 },
];
const ranges = ref({
  '近一周': [dayjs().subtract(7, 'day'), dayjs()],
  '近一月': [dayjs().subtract(1, 'month'), dayjs()],
  '近三月': [dayjs().subtract(3, 'month'), dayjs()],
  '近六月': [dayjs().subtract(6, 'month'), dayjs()],
});
const tradeFormRef = ref();
const uploadRef = ref();
const downloadRef = ref();

const queryForm = ref({
  daterange: ["", ""],
  orgid: "ALL",
  platform: "ALL",
  trade_number: "",
});
const dataLoading = ref(false);
const loading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const total_count = ref(0);
const total_amount = ref(0);
const currencys = ref([]);
const selectedRowKeys = ref([]);
const tradeForm = ref({});
const tradeModal = ref(false);
const saving = ref(false);
const orgs = ref([]);
const platforms = ref([])

const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const qplatforms = computed(() => {
  return [
    { value: 'ALL', label: '全部平台' },
    ...platforms.value,
  ]
});
const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  refresh();
});
const refresh = () => {
  getData();
  getStatistics();
}
const getData = () => {
  selectedRowKeys.value = [];
  dataLoading.value = true;
  proxy.$api.doAPI("/trade/list", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = res.data.list.map(n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, "YYYY-MM-DD HH:mm:ss"),
        };
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      platforms.value = res.data.platforms;
      currencys.value = res.data.currencys;
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const getStatistics = () => {
  loading.value = true;
  proxy.$api.doAPI("/trade/statistics", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    loading.value = false;
    if (res.code === 0) {
      total_count.value = res.data.total_count;
      total_amount.value = res.data.total_amount;
    } else {
      message.error(res.msg);
      loading.value = false;
    }
  }).catch((err) => {
    console.error(err);
  });
}
const initForm = () => {
  return {
    _id: "", orgid: null,
    platform: null, trade_number: "",
    sub_account_number: "", sub_account_name: "",
    receive_account_number: "", shop_name: "",
    amount: "", currency: null,
    settlement_exchange_rate: "",
    trade_time: "",
  };
};
const add = () => {
  tradeForm.value = initForm();
  tradeModal.value = true;
};
const edit = (item) => {
  tradeForm.value = _.pick(item, _.keys(initForm()));
  tradeModal.value = true;
};
///导入数据
const importData = () => {
  uploadRef.value.showUpload({ title: "导入提现明细", type: "trade", platforms: platforms.value });
};
const save = async () => {
  try {
    await tradeFormRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/trade/save", { dataForm: tradeForm.value }).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        tradeModal.value = false;
        refresh();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancelSave = () => {

};
const exportdata = (ids) => {
  return new Promise(resolve => {
    dataLoading.value = true;
    proxy.$api.doAPI("/trade/list", { ...queryForm.value, ids, action: "download" }).then((res) => {
      dataLoading.value = false;
      resolve(true);
    }).catch((err) => {
      dataLoading.value = false;
      resolve(false);
      console.error(err);
    });
  })
}
const exportselected = () => {
  exportdata(selectedRowKeys.value).then((ok) => { if (ok) exporttask() });
}
const exportall = () => {
  exportdata([]).then((ok) => { if (ok) exporttask() });
}
const exporttask = () => {
  downloadRef.value.showDownload({ title: "导出提现明细", type: "trade" });
}
const getorgname = (orgid) => {
  return _.findWhere(orgs.value, { _id: orgid })?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>